<template>
  <v-stage ref="stage" :config="stageSize" @mousedown="handleStageMouseDown">
    <v-layer ref="layer">
      <v-shape
        name="basic"
        :config="{
          sceneFunc: function(context, shape) {
            context.beginPath();

            //context.stroke('red')
            context.moveTo(20, 100);
            context.lineTo(50, 10);

            //context.stroke('orange')
            context.moveTo(50, 10);
            context.lineTo(80, 50);

            //context.stroke('green')
            context.moveTo(80, 50);
            context.lineTo(150, 50);

            context.stroke('blue');
            context.moveTo(150, 50);
            context.lineTo(180, 100);

            // special Konva.js method
            context.fillStrokeShape(shape);
          },
          fill: 'blue',
          stroke: 'black',
          strokeWidth: 2
        }"
      />
      <v-transformer ref="transformer" />
    </v-layer>
  </v-stage>
</template>

<script>
const width = window.innerWidth;
const height = window.innerHeight;

export default {
  data() {
    return {
      stageSize: {
        width: width,
        height: height
      },
      selectedShapeName: ""
    };
  },
  methods: {
    handleStageMouseDown(e) {
      // clicked on stage - clear selection
      // console.log("I am click")
      if (e.target === e.target.getStage()) {
        this.selectedShapeName = "";
        this.updateTransformer();
        return;
      }

      // clicked on transformer - do nothing
      const clickedOnTransformer =
        e.target.getParent().className === "Transformer";
      if (clickedOnTransformer) {
        return;
      }

      // find clicked rect by its name
      const name = e.target.name();
      console.log(name);
      // const rect = this.images.find(r => r.name === name);
      if (name) {
        this.selectedShapeName = name;
      } else {
        this.selectedShapeName = "";
      }
      this.updateTransformer();
    },
    updateTransformer() {
      // here we need to manually attach or detach Transformer node

      const transformerNode = this.$refs.transformer.getStage();
      const stage = transformerNode.getStage();
      const { selectedShapeName } = this;

      const selectedNode = stage.findOne("." + selectedShapeName);
      // do nothing if selected node is already attached
      console.log("Selected Node", selectedNode);
      if (selectedNode === transformerNode.node()) {
        return;
      }
      console.log("Updating", selectedNode);

      if (selectedNode) {
        // attach to another node

        transformerNode.attachTo(selectedNode);
      } else {
        // remove transformer
        transformerNode.detach();
      }
      transformerNode.getLayer().batchDraw();
    }
  }
};
</script>
